import { render, staticRenderFns } from "./orderMonitor.vue?vue&type=template&id=1907bb41&scoped=true"
import script from "./orderMonitor.vue?vue&type=script&lang=js"
export * from "./orderMonitor.vue?vue&type=script&lang=js"
import style0 from "./orderMonitor.vue?vue&type=style&index=0&id=1907bb41&prod&scoped=true&lang=css"
import style1 from "./orderMonitor.vue?vue&type=style&index=1&id=1907bb41&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1907bb41",
  null
  
)

export default component.exports